import React from "react";

import { sidebarOnClicks, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Glyphicon } from "react-bootstrap";
import { Navigation, Link, History } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar";
import UserHandler from "js/utilities/user-handler";
import Api from "js/utilities/fnapi-client";
import FontAwesome from "react-fontawesome";
import * as config from "../../config";
import APP_ICON from "resources/img/loading.gif";

export default React.createClass({

  mixins: [Navigation],

  displayName: "Advanced Developer Guide",

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  getInitialState() {
    let userEmail = UserHandler.getUser().email;
    let browserUrl = config.BROWSER_SITE_URL;
    let bountyUrl = config.BOUNTY_SITE_URL;
    var scrollToElement = initDeepLinkData(this.props);

    return {
      userEmail: userEmail,
      browserUrl: browserUrl,
      bountyUrl: bountyUrl,
      newSessions: "",
      loading: false,
      consoleData: false,
      error: "",
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    sidebarOnClicks();
    mountCode(this);
    this.fetchData();
    this.fetchNewSessionsCount()
  },

  componentWillMount() {
    if (!UserHandler.loggedIn()) {
      return this.context.router.push("/signin");
    }
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    return (
      <div className="dash usage-console">
        <div className="workspace">
          <div className="workspace__container">
            <section>
              <div className="title">
                <Glyphicon glyph="stats" />
                <h2 id="dev-demo-app-usage-console">
                  Dev/Demo App Server Dashboard
                  {(!this.state.loading && this.state.consoleData) &&
                    <span>
                      &nbsp;&nbsp;
                      <a className="zsc_link" href={this.generateUrl()} target="_blank">Open Dashboard Full Screen</a>
                      <a href={this.generateUrl()} target="_blank" id='usage-console-icon'><Glyphicon className="zsc_link_icon" glyph="new-window" /></a>
                    </span>
                  }
                </h2>
              </div>
              <p>Welcome to the FaceTec Server Dashboard!</p>
              <p>To deploy your own Production Version of the FaceTec Server Dashboard, please see the <Link to="/downloads">Downloads Page</Link> and the <Link to="standard-server-and-dashboard">FaceTec Standard Server and Server Dashboard Setup Guide</Link>.</p>
              <hr/>
            </section>
            <section>
              { this.state.loading &&
                <div id="page-loading">
                  <span id="page-loading-text">Loading Server Dashboard...</span>
                </div>
              }

              { !this.state.loading &&
                <div>
                  <h3 id="data-sources">Data Sources</h3>
                  <p>The Dashboard below shows data from User Sessions where:</p>
                  <ul>
                    <li><p><strong>{this.state.userEmail}</strong> was used to register when using the latest FaceTec Demo Apps: <a href="https://apps.apple.com/us/app/zoom-id-check/id1465840596" target="_blank">iOS</a>, <a href="https://play.google.com/store/apps/details?id=com.facetec.zoomlogin&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" target="_blank">Android</a>, <a href={this.state.browserUrl} target="_blank">Browser</a> or <a href={this.state.bountyUrl} target="_blank">Bounty</a>.</p></li>
                    <li><p><Link to="/account">Your Key  for this Account</Link> was used in an App.</p></li>
                  </ul>
                  <hr/>

                  <h3 id="usage-console-notes">Server Dashboard Notes</h3>
                  <ul>
                    <li><p>Demo App Sessions are currently not included in the Search and Fraud List functionality.</p></li>
                    <li><p>Data will only display for Non-Production Apps.</p></li>
                    <li><p><Link to="/general-questions" target="_blank">Please let us know</Link> if you have any feedback or experience unexpected behavior!</p></li>
                  </ul>
                  <hr />
                </div>
              }

              {(!this.state.loading && !this.state.consoleData) &&
                <div className="alert alert-info">
                  <p>There is currently no FaceTec Demo App or SDK Usage data to display for your Application.</p>
                  <p>To start populating data, make sure you are using version 8.2 or above and that you are sending the correct headers in your networking calls as demonstrated in the FaceTec SDK Sample App.</p>
                </div>
              }



              {(!this.state.loading && this.state.consoleData) &&
                <div>
                  {this.state.newSessions != "" &&
                    <div className="alert alert-info">You have <strong>{this.state.newSessions}</strong> New Sessions, use the navigation bar below to take a closer look!</div>
                  }
                  <iframe src={this.generateUrl()} width="100%" height="100%" style={{background: "url('resources/img/loading.gif') 48% 0 no-repeat"}}></iframe>
                </div>
              }
            </section>
            <SDKSidebar menuType="main" title="Advanced Developer Guide"/>
          </div>
        </div>
      </div>
    );
  },

  generateUrl: function() {
    let token = UserHandler.getToken();
    return "https://console.zoomauth.com/dashboard?token=" + token
  },

  // Get all sessions count
  fetchData: function() {
    this.setState({loading: true});
    Api.get("account/current/zoom-server-console/count/all-sessions").then(( response ) => {
      if(response.data && response.data > 0) {
        this.setState({consoleData: response.data});
      }
      this.setState({loading: false});
    }).catch( (error) => {
      this.setState({loading: false});
    });
  },

  // Get new sessions count
  fetchNewSessionsCount: function() {
    var time = UserHandler.getUsageConsoleLastVisited();
    if(time != "") {
      Api.get("account/current/zoom-server-console/new-sessions-count/" + time).then(( response ) => {
        if(response.data && response.data > 0) {
          this.setState({newSessions: response.data});
        }
        UserHandler.setUsageConsoleLastVisited(Math.floor(Date.now() / 1000));
      }).catch( (error) => {

      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/usage-console.jsx